import * as React from 'react';
import Crumb from 'src/react/components/breadcrumbs/components/Crumb';

var Crumbs = function Crumbs(_ref) {
  var crumbs = _ref.crumbs;
  return /*#__PURE__*/React.createElement("ol", {
    className: "breadcrumb"
  }, crumbs.map(function (crumb, i) {
    return /*#__PURE__*/React.createElement(Crumb, {
      key: crumb.id,
      id: crumb.id,
      url: crumb.url,
      title: crumb.title,
      isActive: i === crumbs.length - 1
    });
  }));
};

export default Crumbs;